/**
 * IMPORTS
 */

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Eye, Undo2 } from "lucide-react";

// components
import { Button } from "@components/button/button";
import { Spinner } from "@components/spinner/spinner";
import { DynamicTable } from "@components/table-custom/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/tabs";

// components / pages
import { SearchInputRemessaEmAndamento } from "@pages/client/shipment-in-progress/components/search-remessa-em-andamento";

// hooks
import { useRemessasEmAndamento } from "@/hooks/remessas/remessas-do-cliente-em-andamento";

// store-zustand
import { useStoreZustandRemessaEmAndamento } from "@/store-zustand/cliente/remessas-em-andamento";

// helpers
import { dataTitleTableShipmentProgress } from "./helpers";

const ShippingInProgressPages = () => {
  const router = useNavigate();

  const { remessasEmAndamento, isLoading, paginations } = useRemessasEmAndamento();

  const { setRemessaEmAndamentoUnico } = useStoreZustandRemessaEmAndamento();

  const { currentPage, itemsPerPage, setCurrentPage, totalItemsPage, lastPage } =
    useStoreZustandRemessaEmAndamento();

  const onGoToPage = useCallback(
    (action: number | "prev" | "next") => {
      const newPage =
        action === "prev"
          ? Math.max(1, currentPage - 1)
          : action === "next"
            ? currentPage + 1
            : action;

      setCurrentPage(newPage);
    },
    [currentPage, setCurrentPage]
  );
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Tabs defaultValue="all">
            <div className="flex items-center">
              <TabsList className="">
                <TabsTrigger value="all" className="">
                  Remessas em andamento
                </TabsTrigger>
              </TabsList>
              <div className="ml-auto flex items-center gap-2">
                <Button
                  size="sm"
                  variant="default"
                  className="h-8 gap-1 text-neutral-50"
                  onClick={() => {
                    router("/");
                  }}
                >
                  <Undo2 className="h-3.5 w-3.5" />
                  <span className="sm:whitespace-nowra sr-only text-neutral-50 sm:not-sr-only">
                    Voltar
                  </span>
                </Button>
              </div>
            </div>
            <TabsContent value="all">
              <DynamicTable
                title="Remessas em andamento"
                description="Gerencie suas remessas em andamento e visualize quando quiser."
                isLoadingPage={false}
                data={remessasEmAndamento ?? []}
                totalItems={totalItemsPage}
                itemsPerPage={itemsPerPage}
                onGoToPage={onGoToPage}
                paginations={paginations}
                currentPage={currentPage}
                lastPage={lastPage}
                columns={dataTitleTableShipmentProgress}
                actions={[
                  {
                    icon: Eye,
                    label: "Mais informações",
                    textColor: "text-red-600",
                    onClick: (item: any) => {
                      setRemessaEmAndamentoUnico(item);
                      router("/details-in-progress");
                    },
                  },
                ]}
                childerSearch={<SearchInputRemessaEmAndamento />}
              />
            </TabsContent>
          </Tabs>
        </>
      )}
    </>
  );
};

/**
 * EXPORTS
 */
export { ShippingInProgressPages };
